import {PLAY_SPEED_MODULE, ROLL_MODULE, PLAY_MODULE, RESTART_MODULE} from './algorithm-types.js';

export default superclass => class extends superclass {

    currentAlgorithms = {};
    
    // mapping between orientation AND algo
    algorithmTypes = {
        0: [PLAY_MODULE],
        1: [RESTART_MODULE]
    };


    onNewStep(stepNumber, time) {
        if (stepNumber % 32 === 0) {
            // new bar so schedule automations
            this.scheduleAutomations(stepNumber, time);
        }
        this.updateAutomationRedux(stepNumber);
            
        // first go thru the current algorithms and subtract from the duration
        let algorithmsStillPlaying = {};
        let already = new Set();
        for (let type in this.currentAlgorithms) {
            let algo = this.currentAlgorithms[type];
            if (!already.has(algo)) {
                algo.duration--;
                algo.elapsed++;
                already.add(algo);
            }
            if (algo.duration > 0) {
                algorithmsStillPlaying[type] = algo;
            }
        }

        // now look at the matrix for this step
        let stepDatas = this.matrix[(stepNumber / 2) % 16];
        if (stepDatas) {
            for (let a of stepDatas) {
                if (!a)  {
                    continue;
                }
                let algo = {
                        types: this.getAlgorithmTypes(a),
                        y: a.y,
                        x: a.x,
                        orientation: a.orientation,
                        elapsed: 0,
                        stepNumber: stepNumber, // stepNumber it was triggered at
                        module: a.module,
                        duration: a.size * 2
                };
                algo.types.forEach(
                    type => algorithmsStillPlaying[type] = algo);
            }
            this.currentAlgorithms = algorithmsStillPlaying;
        } else {
            this.currentAlgorithms = algorithmsStillPlaying;
        }

        this.checkOrientations(this.currentAlgorithms);
    }

    checkOrientations(algos) {
        // if orientation has changed then we clear the _getOutputForModule
        // which depends on orientation
        this._getOutputForModule = {};

        /*
        let newOrientation = algos[0] && algos[0].orientation;
        if (this.lastOrientation !== newOrientation) {
        }
        this.lastOrientation = newOrientation;
        */
    }

    getAlgorithmTypes(stepData) {
        return this.algorithmTypes[stepData.orientation] || [];
    }

    get isEmpty() {
        return this.steps.length === 0;
    }

    shouldPlayModule(module) {
        if (this.isEmpty || this.isFreeform(module)) {
            return true;
        }

        let algo = this.currentAlgorithms[PLAY_MODULE] ||
                    this.currentAlgorithms[RESTART_MODULE];

        return algo && this.isModuleRouted(module, algo.orientation);
    }

    isRolling() {
        let algo = this.currentAlgorithms[ROLL_MODULE];
        this.wasRolling = algo !== undefined;
        return {isRolling: algo !== undefined, isNewRoll: algo && algo.elapsed === 0,
                modules: algo && this.getModulesRoutedIn(algo.orientation) };
    }

    getStepForModule(currentStep, module) {
        if (this.isEmpty || this.isFreeform(module)) {
            return currentStep;
        }

        let algo = this.currentAlgorithms[RESTART_MODULE];
                

        if (algo && this.isModuleRouted(module, algo.orientation)) {
            return currentStep - algo.stepNumber;
        }
        return currentStep;
    }

    getSpeedForModule(module) {
        if (this.isEmpty || this.isFreeform(module)) {
            return 1;
        }

        let algo = this.currentAlgorithms[PLAY_SPEED_MODULE];
        if (algo &&
            this.isModuleRouted(module, algo.orientation)) {
            // depending on the y either give back 1/2 speed o 2x
            let y = algo.y;
            if (y < 4) {
                return 2;
            } else if (y===4) {
                return 1;
            } else {
                return 0.5;
            }
        }
        return 1;
    }
}

